export default __webpack_public_path__ + "static/media/snail.49fd6a4a.gif";